export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13023.64fbc8e8.jpg";